require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cloud-20190927-16.json") })
        }
      }, "path---cloud-20190927-16");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cloud-20190927-16!./.cache/json/cloud-20190927-16.json
// module id = 1382
// module chunks = 231608221292675